import {getAlbumShareUrl, getTrackShareUrl} from '@wix/music-shared/dist/src/social-sharing/social-sharing';
import {openNewWindow} from '@wix/music-shared/dist/src/utils/open-new-window/open-new-window';
import {getQueryParams} from '@wix/music-shared/dist/src/utils/queryParams/queryParams';
import {getInstanceId, getOriginalComponentId} from '..';

export const getShareSettings = () => {
  const {tpaApplicationId, pageId} = getQueryParams();

  return {
    tpaApplicationId: tpaApplicationId as string,
    pageId: pageId as string,
    instanceId: getInstanceId(),
    compId: getOriginalComponentId(),
  };
};

function openShareWindow(shareUrl) {
  openNewWindow(shareUrl, 626, 436);
}

export const shareTrack = (social, album, track, siteInfo) => {
  const shareSettings = getShareSettings();
  const {url, baseUrl} = siteInfo;
  const shareUrl = getTrackShareUrl({...shareSettings, siteUrl: url, baseUrl}, social, album, track);

  openShareWindow(shareUrl);
};

export const shareAlbum = (social, album, siteInfo) => {
  const shareSettings = getShareSettings();
  const {url, baseUrl} = siteInfo;
  const shareUrl = getAlbumShareUrl({...shareSettings, siteUrl: url, baseUrl}, social, album);

  openShareWindow(shareUrl);
};
